import { eMode } from "../../../content/enum";
import { IMucThuTinChiActionTypes } from "../../action-types/muc-thu/IMucThuTinChiActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucThuTinChiReducer } from "../../reducer-model/muc-thu/IMucThuTinChiReducer";

const iniState: IMucThuTinChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  sinhViens: [],
  displayMode: window.innerWidth >= 1400 ? "full" : "popup",
  loaiThuChiId: 0,
  kyDangKyId: 0,
  mucThuKhacs: [],
  trangThaiHocs: [0],
  trangThaiTongHop: "all",
};
export const mucThuTinChiReducer = (
  state: IMucThuTinChiReducer = iniState,
  action: IMucThuTinChiActionTypes
): IMucThuTinChiReducer => {
  switch (action.type) {
    case "MUC_THU_TIN_CHI_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_LOAD_HOCSINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TIN_CHI_LOAD_HOCSINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        sinhViens: action.payload,
      };
    case "MUC_THU_TIN_CHI_LOAD_HOCSINH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_CHANGE_LOAI_THU_CHI":
      return {
        ...state,
        loaiThuChiId: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_KY_DANG_KY":
      return {
        ...state,
        kyDangKyId: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_CALCULATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        calculate: {
          isShowModal: true,
          sinhVienLopTinChiSoTiens: [],
        },
      };
    case "MUC_THU_TIN_CHI_CALCULATE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        calculate: {
          ...state.calculate,
          sinhVienLopTinChiSoTiens: action.payload.sinhViens,
          cacheKey: action.payload.cache_key,
        },
      };
    case "MUC_THU_TIN_CHI_CALCULATE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        calculate: {
          ...state.calculate,
          sinhVienLopTinChiSoTiens: [],
        },
      };
    case "MUC_THU_TIN_CHI_UPDATE_CALCULATE_STATE": {
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        calculate: {
          ...state.calculate,
          ...action.payload,
        },
      };
    }
    case "MUC_THU_TIN_CHI_SAVE_CALCULATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_TIN_CHI_SAVE_CALCULATE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        calculate: undefined,
      };
    case "MUC_THU_TIN_CHI_SAVE_CALCULATE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_LOAD_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TIN_CHI_LOAD_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: action.payload,
      };
    case "MUC_THU_TIN_CHI_LOAD_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: [],
      };
    case "MUC_THU_TIN_CHI_CHANGE_TRANG_THAI_HOC":
      return {
        ...state,
        trangThaiHocs: action.payload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_TRANG_TONG_HOP":
      return {
        ...state,
        trangThaiTongHop: action.payload,
      };
    default:
      return state;
  }
};
